import {
  FormContext
} from "../__chunks/P3I4MECH.js";
import {
  useCollectionItem
} from "../__chunks/VFNGSUSF.js";
import "../__chunks/T3DJZG63.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "../__chunks/NQJBHION.js";
import {
  useId,
  useMergeRefs
} from "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/form/form-error.ts
import { useCallback, useContext, useRef } from "react";
import { invariant } from "@ariakit/core/utils/misc";
var useFormError = createHook(
  (_a) => {
    var _b = _a, { store, name: nameProp, getItem: getItemProp } = _b, props = __objRest(_b, ["store", "name", "getItem"]);
    const context = useContext(FormContext);
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "FormError must be wrapped in a Form component"
    );
    const id = useId(props.id);
    const ref = useRef(null);
    const name = `${nameProp}`;
    const getItem = useCallback(
      (item) => {
        const nextItem = __spreadProps(__spreadValues({}, item), { id: id || item.id, name, type: "error" });
        if (getItemProp) {
          return getItemProp(nextItem);
        }
        return nextItem;
      },
      [id, name, getItemProp]
    );
    const children = store.useState(() => {
      const error = store == null ? void 0 : store.getError(name);
      if (error == null)
        return;
      if (!(store == null ? void 0 : store.getFieldTouched(name)))
        return;
      return error;
    });
    props = __spreadProps(__spreadValues({
      id,
      role: "alert",
      children
    }, props), {
      ref: useMergeRefs(ref, props.ref)
    });
    props = useCollectionItem(__spreadProps(__spreadValues({ store }, props), { getItem }));
    return props;
  }
);
var FormError = createMemoComponent((props) => {
  const htmlProps = useFormError(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  FormError.displayName = "FormError";
}
export {
  FormError,
  useFormError
};
